export default "__VITE_ASSET__Drds9_I1__"